import React from 'react';

const DiamondTypeTag = ({ diamondTypeTagColor,diamondTypeTag}) => {
    const ulDiamondStyle = {
        borderRadius: '50%',
        marginTop: 2,
        height: 15,
        width: 15,
        lineHeight: '15px',
        fontSize: 8,
        textAlign: 'center',
        display: 'inline-block',
        fontFamily: 'Rubik',
        borderWidth: 1,
        borderStyle: 'solid',
        ...diamondTypeTagColor
      };
      
    return (
        <>
            <span style={ulDiamondStyle} className="mr-3 small">
                {diamondTypeTag}
            </span>
        </>
    );
};

export default DiamondTypeTag;
